"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeTool = exports.Tool = exports.ToolState = void 0;
const MemoizedString_1 = require("./MemoizedString");
const ObservableEntity_1 = require("./ObservableEntity");
var ToolState;
(function (ToolState) {
    ToolState["HIDDEN"] = "HIDDEN";
    ToolState["DISABLED"] = "DISABLED";
    ToolState["ENABLED"] = "ENABLED";
    ToolState["ACTIVE"] = "ACTIVE";
})(ToolState = exports.ToolState || (exports.ToolState = {}));
class Tool extends ObservableEntity_1.ObservableEntity {
}
exports.Tool = Tool;
function makeTool(data) {
    return new ToolImp(data);
}
exports.makeTool = makeTool;
class ToolImp extends Tool {
    constructor(data) {
        super();
        this.memoizedState = new MemoizedString_1.MemoizedString(ToolState.ENABLED, this.notify);
        this.actions = [];
        this._isAction = false;
        this.registerAction = (action) => {
            this.actions.push(action);
            this._isAction = true;
        };
        this.triggerActions = () => {
            this.actions.forEach((action) => {
                action();
            });
        };
        this.isMyHotkey = (hotkey) => {
            let isMine = false;
            this.hotkeys.forEach((myHotkey) => {
                if (this.hotkeysMatch(myHotkey, hotkey)) {
                    isMine = true;
                }
            });
            return isMine;
        };
        this.type = data.type;
        this.memoizedLabel = new MemoizedString_1.MemoizedString(data.label, this.notify);
        this.isDefault = data.isDefault;
        this.memoizedShortcut = new MemoizedString_1.MemoizedString(data.shortcutLabel, this.notify);
        this.hotkeys = data.hotkeys;
    }
    get label() {
        return this.memoizedLabel.val;
    }
    set label(toolLabel) {
        this.memoizedLabel.val = toolLabel;
    }
    get shortcutLabel() {
        return this.memoizedShortcut.val;
    }
    set shortcutLabel(shorcut) {
        this.memoizedShortcut.val = shorcut;
    }
    get state() {
        return this.memoizedState.val;
    }
    set state(val) {
        this.memoizedState.val = val;
    }
    get isAction() {
        return this._isAction;
    }
    hotkeysMatch(a, b) {
        if (a.keyCode !== b.keyCode)
            return false;
        const aComplete = this.fillInMissingModifiers(a);
        const bComplete = this.fillInMissingModifiers(b);
        if (aComplete.alt !== bComplete.alt)
            return false;
        if (aComplete.control !== bComplete.control)
            return false;
        if (aComplete.meta !== bComplete.meta)
            return false;
        if (aComplete.shift !== bComplete.shift)
            return false;
        return true;
    }
    fillInMissingModifiers(hotkey) {
        const rVal = Object.assign({}, hotkey);
        rVal.alt = hotkey.alt === undefined ? false : hotkey.alt;
        rVal.control = hotkey.control === undefined ? false : hotkey.control;
        rVal.meta = hotkey.meta === undefined ? false : hotkey.meta;
        rVal.shift = hotkey.shift === undefined ? false : hotkey.shift;
        return rVal;
    }
}
